import React from "react";
import moment from "moment";
import { getChatAvatarSrc, getLastMessagePreview } from "../utils";

export default function ChatListItem({
  item,
  userData,
  isCompletedTab,
  editText,
  onSelect,
  onEditClick,
  onEditChange,
  onEditSave,
}) {
  return (
    <div
      onClick={onSelect}
      className={`messaging__chats-item ${
        item?.id === userData?.id ? "messaging__chats-item_active" : ""
      }`}
    >
      <div className="messaging__item-left">
        <div className="messaging__item-avatar">
          {item?.is_online !== null && item?.is_online ? (
            <span className="messaging__item-online">
              <img src="/assets/icons/dot.svg" alt="" />
            </span>
          ) : (
            ""
          )}
          <img src={getChatAvatarSrc(item)} alt="avatar" />
        </div>
        <div className="messaging__item-info">
          {!isCompletedTab ? (
            <p className="messaging__item-name">{item?.name}</p>
          ) : (
            <div>
              {item?.isEditing ? (
                <div className="messaging__item-editable">
                  <input
                    className="edit-input"
                    autoFocus={true}
                    type="text"
                    value={editText}
                    onChange={onEditChange}
                    onClick={(event) => {
                      event.stopPropagation();
                    }}
                  />
                  <img
                    className="hide-input messaging__item-edit-icon"
                    onClick={(event) => onEditSave(event, item)}
                    src="/assets/icons/edit-messaging.svg"
                    alt="edit"
                  />
                </div>
              ) : (
                <div className="messaging__item-editable">
                  <p className="messaging__item-name">{item?.name}</p>
                  <img
                    className="show-input messaging__item-edit-icon"
                    onClick={(event) => onEditClick(event, item)}
                    src="/assets/icons/edit-messaging.svg"
                    alt="edit"
                  />
                </div>
              )}
            </div>
          )}
          {item?.type !== "support" && item?.job_title && (
            <div className="messaging__item-id">Job ID# {item?.job_title}</div>
          )}
          <p className="messaging__item-text">{getLastMessagePreview(item)}</p>
        </div>
      </div>
      <div className="messaging__item-right">
        {item?.last_message !== null && (
          <p className="messaging__item-time">
            {moment(item?.last_message?.updated_at).format("hh:mm A")}
          </p>
        )}
        {item?.unread_messages_count !== 0 &&
          item?.unread_messages_count !== null &&
          item?.unread_messages_count !== undefined &&
          item?.id !== userData?.id && (
            <div className="messaging__item-count">{item?.unread_messages_count}</div>
          )}
      </div>
    </div>
  );
}
